<template>
  <div class="flex justify-center my-10">
    <div
      id="Img"
      @click="downloadAsImg('Img')"
      class="p-0 m-0 relative"
      style="width: 736px; height: 1078px;"
    >
      <div class="absolute inset-0 z-10">
        <div class="flex justify-around text-3xl mb-8" style="margin-top: 533px">
          <p class="pr-5">Department</p>
          <p class="pl-5">Interior Designer</p>
        </div>
        <p class="text-blue-400 text-center font-bold text-6xl underline mb-2">Name Surname</p>
        <p class="text-blue-400 text-center font-bold text-6xl underline" style>Designation</p>
        <div class="flex justify-around">
          <div>
            <p>Join On</p>
            <p>DOB</p>
            <p>Call</p>
          </div>
          <div></div>
        </div>
      </div>

      <img src="http://floret-college.test/images/staffId.jpg" />
    </div>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
onMounted(() => {
  var scripts = [
    "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js",
    "https://html2canvas.hertzen.com/dist/html2canvas.min.js",
    "https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.0/FileSaver.min.js"
  ];
  scripts.forEach(script => {
    let tag = document.createElement("script");
    tag.setAttribute("src", script);
    document.head.appendChild(tag);
  });
});

function downloadAsImg(divId) {
  html2canvas(document.querySelector(`#${divId}`)).then(canvas => {
    canvas.toBlob(function(blob) {
      window.saveAs(blob, "my_image.jpg");
    });
  });
}
</script>